import type { Theme } from '@mui/material'
import type { SystemStyleObject } from '@mui/system'

export const AVATAR_BASE_SX: SystemStyleObject<Theme> = {
  textTransform: 'uppercase',
  margin: '1rem',
}

export const AVATAR_SIZE_SX = {
  small: { fontSize: '1rem', width: '2.5rem', height: '2.5rem' },
  large: { fontSize: '1.5rem', width: '4.5rem', height: '4.5rem' },
} satisfies Record<string, SystemStyleObject<Theme>>

/** Colours by whose avatar it is: the signed-in user, a provider, a patient, or anyone else. */
export const AVATAR_OWNER_SX = {
  patient: { bgcolor: 'grey.50', color: 'text.primary' },
  provider: { bgcolor: 'primary.lighter', color: 'text.primary' },
  me: { bgcolor: 'primary.main', color: 'common.white' },
  other: {
    bgcolor: 'common.white',
    border: theme => `1px solid ${theme.palette.secondary[300]}`,
    color: 'secondary.400',
  },
} satisfies Record<string, SystemStyleObject<Theme>>
